import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { supabase } from '../lib/supabaseClient';

function TopNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    async function run() {
      try {
        if (!user) { if (!cancelled) setIsSuperAdmin(false); return; }
        const { data } = await supabase.auth.getSession();
        const token = data?.session?.access_token;
        if (!token) { if (!cancelled) setIsSuperAdmin(false); return; }
        const url = (process.env.REACT_APP_SKINNY_SUPABASE_URL || '').replace(/\/+$/,'') + '/functions/v1/user-is-superadmin';
        const res = await fetch(url, { method: 'POST', headers: { Authorization: 'Bearer ' + token, apikey: process.env.REACT_APP_SKINNY_SUPABASE_ANON_KEY || '' } });
        if (!res.ok) { if (!cancelled) setIsSuperAdmin(false); return; }
        const json = await res.json();
        if (!cancelled) setIsSuperAdmin(!!json.is_superadmin);
      } catch {
        if (!cancelled) setIsSuperAdmin(false);
      }
    }
    run();
    return () => { cancelled = true; };
  }, [user]);
  return (
    <Navbar bg="white" className="border-bottom" expand="md" sticky="top" expanded={expanded} onToggle={setExpanded}>
      <Container>
        <Navbar.Brand as="a" href="/home.html">
          <img src="/TSAIByS2R.svg" alt="TheSkinnyAI" height="42" style={{ display: 'inline-block', verticalAlign: 'middle' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="nav" />
        <Navbar.Collapse id="nav" className="justify-content-end">
          <Nav>
            {!user && (
              <>
                <Nav.Link as="a" href="/home.html" onClick={() => setExpanded(false)}>Home</Nav.Link>
                <Nav.Link as={Link} to="/pricing" onClick={() => setExpanded(false)}>Pricing</Nav.Link>
                <Nav.Link as="a" href="/faq/index.html" onClick={() => setExpanded(false)}>FAQ</Nav.Link>
                <Nav.Link as="a" href="/about.html" onClick={() => setExpanded(false)}>About</Nav.Link>
                <Nav.Link as="a" href="/insights.html" onClick={() => setExpanded(false)}>Resources</Nav.Link>
                <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact</Nav.Link>
                <Button variant="outline-primary" className="ms-2" onClick={() => { setExpanded(false); navigate('/login'); }}>Login</Button>
              </>
            )}
            {user && (
              <>
                <Nav.Link as={Link} to={'/dashboard'} onClick={() => setExpanded(false)}>Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/pricing" onClick={() => setExpanded(false)}>Pricing</Nav.Link>
                <Nav.Link as="a" href="/faq/index.html" onClick={() => setExpanded(false)}>FAQ</Nav.Link>
                <Nav.Link as="a" href="/about.html" onClick={() => setExpanded(false)}>About</Nav.Link>
                <Nav.Link as="a" href="/insights.html" onClick={() => setExpanded(false)}>Resources</Nav.Link>
                <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact</Nav.Link>
                {isSuperAdmin && (
                  <Nav.Link as={Link} to="/superadmin" onClick={() => setExpanded(false)}>SuperAdmin</Nav.Link>
                )}
                <Button variant="outline-secondary" className="ms-2" onClick={async () => { 
                  try {
                    setExpanded(false); 
                    await logout(); 
                  } finally {
                    navigate('/login', { replace: true });
                  }
                }}>Logout</Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default TopNav;


